import SplitScreenComponent from 'components/containers/SplitScreenComponent';
import SignUpFlow from 'components/generics/flows/LoginSignUpFlow/SignUpFlow';
import PublicOnly from 'hocs/PublicOnly';
import React from 'react';
import classes from './index.module.scss';
import ResidentSignUpAnimation from '../../../components/animations/ResidentSignUpAnimation';

const SignupPage = () => {
  return (
    <SplitScreenComponent
      LeftComponent={<ResidentSignUpAnimation />}
      RightComponent={<SignUpFlow tenant={true} />}
      rightContainerClassName={classes.rightContainer}
      leftContainerClassName={classes.leftContainer}
      rightContentClassName={classes.rightContent}
    />
  );
};

export default PublicOnly(SignupPage);
